import * as React from 'react';

import _ from 'lodash';

import { Loading as _Loading } from '@coursera/coursera-ui';

export type LoadingIndicatorInterface = {
  /** Opt in load method, called in wrapper componentDidMount. Useful for triggering loads for components that themselves start in a loading state. */
  load?(): void;
  /** If true, wrapped component will be swapped out for the canonical loading spinner. */
  loading?: boolean;
};

/**
 * If component is busy, replace with loading component.
 *
 * Designed for use with components that do not implement their own loading.
 * Does not pass on `loading` prop.
 */
export const withLoadingIndicator =
  <P extends {}>({ Loading = _Loading }: { Loading?: React.ComponentType } = {}) =>
  (WrappedComponent: React.ComponentType<P>): React.ComponentType<P & LoadingIndicatorInterface> => {
    return class Wrapper extends React.Component<P & LoadingIndicatorInterface> {
      static displayName = `withLoadingIndicator(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      componentDidMount() {
        _.result(this.props, 'load');
      }

      render() {
        const { loading, ...props } = this.props;
        if (loading) {
          return <Loading />;
        } else {
          // Working around spread props typing issues when we want to omit a prop.
          return <WrappedComponent {...(props as P)} />;
        }
      }
    };
  };

export default withLoadingIndicator;
